import { render, staticRenderFns } from "./ProductOrderView.vue?vue&type=template&id=1057f352"
import script from "./ProductOrderView.vue?vue&type=script&lang=js"
export * from "./ProductOrderView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports